/**
 * このファイルにはpropsやstateを元に共通処理をする関数を定義しています。
 */

/**
 * 機能が利用できるかどうかを判定
 * @param  {object} componentStateProps props や state
 * @param  {string} functionName
 * @return {bool} true: 利用可能, false: 利用不可
 */
export const isEnableFunction = (componentStateProps, functionName) => {
  return (typeof componentStateProps[functionName] === 'function');
}



// WEBPACK FOOTER //
// ./src/utils/componentUtils.js